<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/xllh/rcrclc.png" alt="" />
            <div class="technological-process">
                <div class="zcjj">
                    <img class="top" style="height: 1.12rem" src="./../assets/imgs/xllh/rcgyysq_zcjj.png" alt="" />
                    <div class="content">
                        <div class="des">
                            “蓉城人才绿卡”是符合条件的高层次人才在成都市域内按照相关规定享受政务
                            、创新创业、商务和生活等专属服务保障的有效凭证，分为市级卡（即“蓉城人才绿卡”市级卡与“天府英才卡A卡”的联名卡）和区县卡。
                        </div>
                    </div>
                </div>
                <div class="rhtj mar-t2">
                    <img class="top" src="./../assets/imgs/xllh/rcgysq_sqdx.png" alt="" />
                    <div class="content">
                        <!-- <div class="title">
                            <span class="hollow-cricle"></span>市级卡
                        </div> -->
                        <div class="des mar-t2">
                            <div class="describe mar-t2">
                                <div style="display: flex" class="describe-item mar-t3">
                                    <div class="num">1</div>
                                    <div class="" style="line-height: 0.44rem">
                                        中国科学院院士和中国工程院院士;
                                    </div>
                                </div>
                                <div style="display: flex" class="describe-item mar-t3">
                                    <div class="num">2</div>
                                    <div class="" style="line-height: 0.44rem">
                                        中央和省委掌握联系高层次人才；
                                    </div>
                                </div>
                                <div style="display: flex" class="describe-item mar-t3">
                                    <div class="num">3</div>
                                    <div class="" style="line-height: 0.44rem">
                                        国家高层次人才特殊支持计划人选;国家海外高层次人才引进计划人选;天府峨眉计划人选;天府青城计划人选;“蓉漂计划”人选;“蓉城英才计划”人选;
                                    </div>
                                </div>
                                <div style="display: flex" class="describe-item mar-t3">
                                    <div class="num">4</div>
                                    <div class="" style="line-height: 0.44rem">
                                        “四川杰出人才奖”“天府友谊奖”“金沙友谊奖”获得者;
                                    </div>
                                </div>
                                <div style="display: flex" class="describe-item mar-t3">
                                    <div class="num">5</div>
                                    <div class="" style="line-height: 0.44rem">
                                        根据经济社会发展需要，由相关行业主管部门和区（市）县推荐的其他高层次人才;
                                    </div>
                                </div>
                                <div style="color:#3D5AA3;margin-top: 0.2rem;">注:以上内容为市级卡条件，区县卡申请条件具体详询所在区（市）县委人才办。</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/xllh/rcrclc_fwsx.png" alt="" />
                    <div class="content">
                        <div class="des">
                            <img class="title-img" src="./../assets/imgs/xllh/rcrclc_sjc.png" alt="" />
                            持卡人可享受住房、落户、子女入园入学、医疗、出入境和停居留便利、创业扶持等20余个市级服务事项及所属区（市）县提供的个性化服务事项。主要包括：在成都以本人名义首次购房时，可不受户籍、社保、限购区域限制;免费乘坐5+1区域公交和全市地铁;在市属指定三甲医院可享受绿色就医通道等。
                            <br />（具体请参考《“蓉城人才绿卡”人才服务手册》）
                        </div>
                        <div class="des">
                            <img class="title-img" src="./../assets/imgs/xllh/rcrclc_qxk.png" alt="" />
                            由各区（市）县根据专家人才服务需求，自行研究提出具有本地特色的服务事项。【具体详询所在区（市）县委人才办】
                        </div>
                    </div>
                </div>
                <div class="gmlc">
                    <img class="top" src="./../assets/imgs/xllh/rpqnrcyz_bllc.png" alt="" />
                    <div class="content">
                        <div class="title">
                            <span class="hollow-cricle"></span>如何申请“蓉城人才绿卡” ？
                        </div>
                        <div class="des mar-t3">
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">1</div>
                                    <div class="line-title">填写申请表</div>
                                </div>
                                <div class="line-content">
                                    关注“人才成都”微信公众号，点击菜单栏“人才服务”-“人才绿卡”-“申请表“下载《”蓉城人才绿卡“申请表信息确认表》。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">2</div>
                                    <div class="line-title">提交申请材料</div>
                                </div>
                                <div class="line-content">
                                    将申请材料提交或邮寄至成都人才综合服务中心人才绿卡服务专席。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">3</div>
                                    <div class="line-title">发送照片</div>
                                </div>
                                <div class="line-content">
                                    近期2寸白底免冠电子档照片发送至邮箱RongchengTalent@163.com。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">4</div>
                                    <div class="line-title">资格初审</div>
                                </div>
                                <div class="line-content">
                                    人才绿卡服务专席工作人员对申领人资格进行初审。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">5</div>
                                    <div class="line-title">资格复核</div>
                                </div>
                                <div class="line-content">
                                    市委组织部对申领人资格进行复核。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">6</div>
                                    <div class="line-title">等待反馈</div>
                                </div>
                                <div class="line-content">
                                    成都人才综合服务中心绿卡服务专席人员向申领人反馈审核结果。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line-top">
                                    <div class="line-num">7</div>
                                    <div class="line-title">审核结果</div>
                                </div>
                                <div class="line-content">
                                    制卡完成后，成都人才综合服务中心绿卡服务专席工作人员通知人才领卡。
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="contact">
                    <img class="top" src="./../assets/imgs/xllh/rclk-dwdh.png" alt="" />
                    <div class="content" style="font-size: 0.3rem;">
                        全年。
                    </div>
                </div>
                <div class="contact">
                    <img class="top" src="./../assets/imgs/xllh/rclk-sqsj.png" alt="" />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:400-116-9366">400-116-9366</a>

                            </div>
                            <div><a href="tel:028-83221725">028-83221725</a></div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            成都人才综合服务中心人才绿卡服务专席
                        </div>
                    </div>
                </div>
                <div class="sqsj">
                    <img style="width: 100%;" src="./../assets/imgs/xllh/rclk-code.png" alt="" />
                    <!-- <div class="rcrclc-zhfwpt">
                        <img src="./../assets/imgs/xllh/rcrclc_zhfwpt_code.png" alt="" />
                    </div> -->
                </div>
            </div>
        </section>
        <call phone="400-116-9366"></call>
    </div>
</template>

<script>
// import bottom from "../components/bottom.vue";
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        // bottom,
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 5.6rem;
    }

    .technological-process {
        transform: translateY(-1.9rem);

        .zcjj {

            // background-color:#fff;
            .top {
                width: 6.68rem;
                height: 2.12rem;
            }

            .content {
                width: 6.68rem;
                background: #ffffff;
                margin: -0.45rem auto 0;
                padding: 0.1rem 0.33rem 0.4rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                line-height: 0.44rem;

                .title {
                    font-size: 0.34rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;
                    line-height: 0.44rem;
                    text-align: left;
                    margin-top: 0.16rem;
                }
            }
        }

        .rhtj {
            position: relative;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem 0.3rem;
                    text-align: left;
                    line-height: 0.44rem;
                    position: relative;

                    .describe {
                        background: linear-gradient(180deg,
                                #ffffff 0%,
                                rgba(255, 255, 255, 0) 100%);
                        border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                        opacity: 1;
                        padding: 0rem 0.33rem 0 0.15rem;

                        .num {
                            min-width: 0.39rem;
                            height: 0.39rem;
                            background: #739bfe;
                            color: #ffffff;
                            display: inline-flex;
                            border-radius: 50%;
                            justify-content: center;
                            align-items: center;
                            margin-right: 0.14rem;
                        }
                    }

                    img {
                        position: absolute;
                        width: 1.74rem;
                        height: 0.6rem;
                        top: 0;
                        left: 0;
                    }
                }
            }
        }

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.68rem 0.23rem 0.3rem;
                    margin-top: 0.5rem;
                    position: relative;

                    .title-img {
                        position: absolute;
                        left: 50%;
                        top: 0rem;
                        width: 4.46rem;
                        height: 0.67rem;
                        transform: translate(-50%, -50%);
                    }
                }
            }
        }

        .gmlc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem;
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;
                    line-height: 0.44rem;

                    .line-item {
                        font-size: 0.26rem;
                        position: relative;
                        z-index: 3;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 100%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .line-title {
                            font-size: 0.3rem;
                            font-weight: bold;
                            color: #3d5aa3;
                            line-height: 0.46rem;
                        }

                        .line-top {
                            display: flex;

                            .line-num {
                                min-width: 0.39rem;
                                height: 0.39rem;
                                background: #739bfe;
                                color: #ffffff;
                                display: inline-flex;
                                border-radius: 50%;
                                justify-content: center;
                                align-items: center;
                                margin-right: 0.14rem;
                                position: relative;
                                z-index: 3;
                            }
                        }

                        .line-content {
                            //   border-left: 0.02rem dashed #739bfe;
                            padding-bottom: 0.32rem;
                            margin-left: 0.2rem;
                            padding-left: 0.32rem;
                            padding-top: 0.15rem;
                            word-break: break-all;
                            line-height: 0.44rem;
                        }
                    }

                    .des-item {
                        font-size: 0.26rem;
                        font-weight: 500;
                        color: #4e4e4e;
                        padding-left: 0.33rem;
                        padding-top: 0.22rem;
                        margin-left: 0.2rem;
                        border-left: 0.02rem dashed #739bfe;
                        padding-bottom: 0.55rem;

                        .cdrcwewm {
                            width: 5.51rem;
                            height: 1.43rem;
                            margin-top: 0.16rem;
                        }
                    }

                    .describe-item {
                        font-size: 0.26rem;
                        font-weight: 500;
                        color: #4e4e4e;
                        padding-left: 0.33rem;
                        padding-top: 0.22rem;
                        margin-left: 0.2rem;
                        word-break: break-all;
                    }
                }
            }
        }

        .sqsj {
            width: 6.85rem;
            background: #ffffff;
            border-radius: 0.26rem 0.26rem 0.26rem 0.26rem;
            margin: 0.3rem auto 0;
            box-sizing: border-box;
            text-align: left;
            padding: 0.3rem;
            padding-bottom: 0.15rem;

            .rcrclc-sqsj {
                width: 5.58rem;
                height: 1.94rem;
                margin-top: 0.3rem;
                background-image: url("./../assets/imgs/xllh/rcrclc_sqsj.png");
                background-size: 100% 100%;
                background-repeat: no-repeat;
                margin: 0 auto;

                img {
                    width: 1.94rem;
                    height: 1.94rem;
                }
            }

            .rcrclc-zhfwpt {
                width: 5.58rem;
                height: 1.94rem;
                margin-top: 0.3rem;
                background-image: url("./../assets/imgs/xllh/rcrclc_zhfwpt.png");
                background-size: 100% 100%;
                background-repeat: no-repeat;
                margin: 0.3rem auto 0;

                img {
                    width: 1.94rem;
                    height: 1.94rem;
                }
            }
        }
    }
}
</style>
